import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'

import {SocialImage} from '../../../components';
import providersStore from '../../../services/providers/ProvidersStore';
import SocialReplyItem from '../posts/postDetails/SocialReplyItem'

class SocialTask extends Component {
  static propTypes = {
    onStatusChanged: PropTypes.func.isRequired
  };

  renderAttachments(post){
    let attachment;
    if(post.attachments && post.attachments.length){
      let first = post.attachments[0];
      switch(first.attachmentType){
        case "Image":
          attachment = <div className="col-6 mb-4"><img src={first.url} style={{width: '100%'}} /></div>
          break;
      }
      return attachment
    }
  }
  render() {
    const {post} = this.props;
    const attachments = this.renderAttachments(post);

    return(
      <Fragment>
        <div className="d-flex flex-row mb-4">
          <div className="pr-4">
            <SocialImage
              userImage={post.avatar}
              username={post.username}
              provider={post.provider}
              providers={providersStore.providers} />
          </div>
          <div>
            <h5>{post.username}</h5>
            {post.text}
            <div className="row justify-content-md-center">
              {attachments}
            </div>

          </div>
        </div>
        <div className="d-flex flex-column mb-4">
          <SocialReplyItem
            hideWorkflowTask={true}
            index={1} item={post} depth={0}
            onApprove={this.props.onStatusChanged} onReject={this.props.onStatusChanged}
            onDelete={this.props.onStatusChanged} onUpdate={this.props.onStatusChanged}/>
        </div>
      </Fragment>
    );
  }
}

export default SocialTask;
